import React, { memo, useCallback } from 'react';
import { ViewProps } from 'react-native';

import { useNavigation } from '@react-navigation/native';

import { useLobbySectionSelection } from '@/feature/lobby/hooks/use-lobby-section-selection';
import { PickemLobbyTabNavigationProp } from '@/navigation/pickem/types';
import { League } from '@/types/api.generated';
import { addResizeParamToURL } from '@/utils/cdn-utils';

import { usePlayerFiltersActions } from '../hooks/use-player-filters';
import { LaunchpadTile } from './LaunchpadTile';

type LeagueButtonTitleProps = {
    league: League;
    label: string;
    testID?: string;
    eventsCount?: number;
    icon?: string;
    isLive?: boolean;
    updateTab?: () => void;
    onLayout?: ViewProps['onLayout'];
    isLastItem?: boolean;
};

export const PickemLeagueTile = memo(
    ({ eventsCount, league, label, testID, icon, isLive, onLayout, updateTab, isLastItem }: LeagueButtonTitleProps) => {
        const { setParams } = useNavigation<PickemLobbyTabNavigationProp>();
        const { resetAllFilters } = usePlayerFiltersActions();
        const setSelectedTile = useLobbySectionSelection(state => state.actions.setSelectedTile);
        const selected = useLobbySectionSelection(state => state.selectedTile === league);

        const handlePress = useCallback(() => {
            if (league) {
                updateTab?.();
                setParams({
                    league: league,
                });
                setSelectedTile(league);
                resetAllFilters();
            }
        }, [league, resetAllFilters, setParams, setSelectedTile, updateTab]);

        return (
            <LaunchpadTile
                onLayout={onLayout}
                disabled={!eventsCount}
                icon={icon ? addResizeParamToURL(icon, 96) : undefined}
                label={label}
                onPress={handlePress}
                testID={testID}
                selected={selected}
                isLive={isLive}
                isLastItem={isLastItem}
                paddingTop={'s14'}
            />
        );
    }
);

PickemLeagueTile.displayName = 'PickemLeagueTile';
